import { FunctionComponent, useEffect, useRef } from 'react'
import { useMap } from '@vis.gl/react-google-maps'
import { VehicleLocation } from 'server'
import { orange } from '@ant-design/colors'

interface IProps {
  vehicleLocations: VehicleLocation[]
  selectedVehicleId?: number
  followedVehicleId?: number
}

const VehicleLocationTrail: FunctionComponent<any> = (props: IProps) => {
  const { vehicleLocations, selectedVehicleId, followedVehicleId } = props

  const map = useMap()

  const color = orange[5]

  const arrowSymbol = {
    path: google.maps.SymbolPath.FORWARD_OPEN_ARROW,
    scale: 2, // Size of the arrow
    strokeColor: color, // Arrow color
    fillColor: color // Fill color of the arrow
  }

  const polylineRef = useRef(
    new google.maps.Polyline({
      map,
      strokeColor: color,
      strokeOpacity: 1.0,
      strokeWeight: 5,
      icons: [
        {
          icon: arrowSymbol,
          offset: '100%', // Place the first arrow at the end of the polyline
          repeat: '50px' // Distance between repeated arrows
        }
      ]
    })
  )

  const path = vehicleLocations.map((vehicleLocation: VehicleLocation) => {
    return {
      lat: vehicleLocation.latitude,
      lng: vehicleLocation.longitude
    }
  })

  polylineRef.current.setPath(path)
  polylineRef.current.setMap(map)

  /*
  if ((selectedVehicleId && path.length > 5) && !followedVehicleId) {
    const bounds = new google.maps.LatLngBounds()
    path.forEach((point) => bounds.extend(point))
    map?.fitBounds(bounds, {
      top: 200,
      right: 400,
      bottom: 200,
      left: 400
    })
  }
   */

  useEffect(() => {
    return () => {
      polylineRef.current.setMap(null)
    }
  }, [])

  return null
}

export default VehicleLocationTrail
